import React, { Component } from 'react';
import dayjs from "dayjs";
import axios from "axios";
import ApiURL from "../../../api/ApiURL";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import cogoToast from "cogo-toast";

class CarSubBooking extends Component {
    constructor(props) {
        super(props);
        const animatedComponents = makeAnimated();
        this.state = {
            AnimatedComponents: animatedComponents,
            tcData: props.tcData || [],
            locationData: props.locationData || [],
            vendorData: props.vendorData || [],
            carData: props.carData || [],
            vendorCategoryId: props.vendorCategoryId || 0, //Car Vendor
            subBookingId: props.subBookingId || 0,
            subBookingNo: props.subBookingNo || '',
            subBookingType: props.subBookingType || 'Car',
            bookingId: props.bookingId,
            travelCircuitId: props.travelCircuitId || 0,
            locationId: props.locationId || 0,
            vendorId: props.vendorId || 0,
            carId: props.carId || '',
            selectedCar: props.selectedCar || [],
            noOfCars: props.noOfCars || '',
            pickupPoint: props.pickupPoint || '',
            dropPoint: props.dropPoint || '',
            checkInDate: props.checkInDate || '',
            checkOutDate: props.checkOutDate || '',
            comment: props.comment || '',
            payableAmount: props.payableAmount || 0,
            paidAmount: props.paidAmount || 0,
            dueAmount: props.dueAmount || 0,
            userId: props.userId || 1,
            isActive: props.isActive || true,
        };
    }
    //ComponentDidUpdate
    componentDidUpdate(prevProps) {
        const prevPropsString = JSON.stringify(prevProps);
        const currentPropsString = JSON.stringify(this.props);

        if (prevPropsString !== currentPropsString) {
            // Update state with new props
            this.setState({
                ...this.state,
                tcData: this.props.tcData,
                locationData: this.props.locationData,
                vendorData: this.props.vendorData,
                carData: this.props.carData,
                vendorCategoryId: this.props.vendorCategoryId,
                subBookingId: this.props.subBookingId,
                subBookingNo: this.props.subBookingNo,
                subBookingType: this.props.subBookingType,
                bookingId: this.props.bookingId,
                travelCircuitId: this.props.travelCircuitId,
                locationId: this.props.locationId,
                vendorId: this.props.vendorId,
                carId: this.props.carId,
                selectedCar: this.props.selectedCar,
                noOfCars: this.props.noOfCars,
                checkInDate: this.props.checkInDate,
                checkOutDate: this.props.checkOutDate,
                pickupPoint: this.props.pickupPoint,
                dropPoint: this.props.dropPoint,
                comment: this.props.comment,
                payableAmount: this.props.payableAmount,
                paidAmount: this.props.paidAmount,
                dueAmount: this.props.dueAmount,
                userId: this.props.userId,
                isActive: this.props.isActive,
            });
        }
    }
    onChangeCar = (selected) => {
        this.props.onChangeCarHandler(selected);
        /* var self = this;
        self.setState({
            selectedCar: selected,
            noOfCars: selected.length
        }) */
    }
    //OnChangeHandler
    onChangeHandler = (e) => {
        this.props.subBookingHandler(e);
    }
    //Save Sub-Booking
    saveSubBooking = (e) => {
        e.preventDefault();

        if (this.state.travelCircuitId === 0) {
            cogoToast.error("Travel Circuit is required!", { position: "bottom-center" });
        }
        else if (this.state.locationId === 0) {
            cogoToast.error("Location is required!", { position: "bottom-center" });
        }
        else if (this.state.vendorId === 0) {
            cogoToast.error("Car vendor is required!", { position: "bottom-center" });
        }
        else if (this.state.selectedCar.length === 0) {
            cogoToast.error("car name is required!", { position: "bottom-center" });
        }
        else if (this.state.noOfCars === '') {
            cogoToast.error("No. of Car is required!", { position: "bottom-center" });
        }
        else if (this.state.pickupPoint === '') {
            cogoToast.error("Pickup point is required!", { position: "bottom-center" });
        }
        else if (this.state.dropPoint === '') {
            cogoToast.error("Drop point is required!", { position: "bottom-center" });
        }
        else if (this.state.checkInDate === '') {
            cogoToast.error("Start date is required!", { position: "bottom-center" });
        }
        else if (this.state.checkOutDate === '') {
            cogoToast.error("End date is required!", { position: "bottom-center" });
        }
        else if (this.state.payableAmount === '' || this.state.payableAmount === 0) {
            cogoToast.error("Vendor payable amount is required!", { position: "bottom-center" });
        }
        else {
            let selectedTravelCircuitId = parseInt(this.state.travelCircuitId);
            let selectedLocationId = parseInt(this.state.locationId);
            let selectedVendorId = parseInt(this.state.vendorId);
            let payableAmt= parseFloat(this.state.payableAmount);
            let selectedCarIds = this.state.selectedCar.map((item) => item.value)?.toString();
            const selectedTravelCircuitName = this.state.tcData.find(v => v.TravelCircuitId === selectedTravelCircuitId)?.TravelCircuitName;
            const selectedLocationName = this.state.locationData.find(v => v.LocationId === selectedLocationId)?.LocationName;
            const selectedVendorName = this.state.vendorData.find(v => v.VendorId === selectedVendorId)?.VendorName;
            //const selectedBookingNo = this.state.subBookingNo != '' ? this.state.subBookingNo : dayjs(new Date()).format('DDMMYYhhmmss');
            
            let subBooking = {
                SubBookingId: this.state.subBookingId,
                SubBookingNo: '',
                SubBookingType: this.state.subBookingType,
                BookingId: this.state.bookingId,
                TravelCircuitId: selectedTravelCircuitId,
                TravelCircuitName: selectedTravelCircuitName,
                LocationId: selectedLocationId,
                LocationName: selectedLocationName,
                VendorId: selectedVendorId,
                VendorName: selectedVendorName,
                CarId: selectedCarIds,
                NoofCars: this.state.noOfCars,
                PickupPoint: this.state.pickupPoint,
                DropPoint: this.state.dropPoint,
                CheckInDate: this.state.checkInDate,
                CheckOutDate: this.state.checkOutDate,
                Comment: this.state.comment,
                PayableAmount: payableAmt,
                PaidAmount: this.state.paidAmount,
                DueAmount: this.state.dueAmount,
                UserId: this.state.userId,
                IsActive: true
            };

            //API call to save individual sub-booking data
            axios
                .post(ApiURL.SaveSubBooking, subBooking)
                .then((response) => {
                    let respData = response.data;
                    console.log(respData);
                    if (respData.StatusCode === 200) {
                        cogoToast.success(respData.Message, { position: "bottom-center" });
                        let sbData = respData.DataResult;
                        if (sbData !== null) {
                            subBooking.SubBookingId = sbData.SubBookingId;
                            subBooking.SubBookingNo = sbData.SubBookingNo;
                            this.props.addSubBookings(subBooking);
                            this.closeModal();
                        }
                    }
                    else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                        cogoToast.warn(respData.Message, { position: "bottom-center" });
                    }
                    else if (respData.StatusCode === 500) {
                        cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                    }
                })
                .catch((error) => {
                    cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                });            
        }
    }
    //Reset Fields
    resetFields = () => {
        this.setState({
            subBookingId: 0,
            subBookingNo: '',
            subBookingType: '',
            bookingId: 0,
            travelCircuitId: 0,
            locationId: 0,
            vendorId: 0,
            carId: '',
            noOfCars: '',
            pickupPoint: '',
            dropPoint: '',
            checkInDate: '',
            checkOutDate: '',
            comment: '',
            payableAmount: 0,
            paidAmount: 0,
            dueAmount: 0,
            isActive: true
        })
    }
    //Close Modal
    closeModal = () => {
        this.resetFields();
        this.props.closeModal();
    }
    render() {
        const { subBookingNo, tcData, locationData, vendorData, travelCircuitId, locationId, vendorId, noOfCars, selectedCar,
            pickupPoint, dropPoint, checkInDate, checkOutDate, comment, payableAmount, paidAmount, dueAmount } = this.state;
        return (
            <>
                {/* <!-- Car modal section--> */}
                <div className={this.props.showModal === true ? "modal show-modal  modalWrapper" : "modal"}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">
                                    Manage {this.props.subBookingType} Sub-Booking
                                    {subBookingNo !== '' ? ' ['+subBookingNo+'] ' : ''}
                                </h3>
                                <i className="fa-regular fa-circle-xmark text-danger" onClick={this.closeModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row"></div>
                                <form>
                                    <div className="row g-3">
                                        <div className="col-md-4">
                                            <label className="form-label">Travel Circuit <span className='text-danger'>*</span></label>
                                            <select
                                                name="travelCircuitId"
                                                value={travelCircuitId}
                                                className="form-control-sm border border-primary form-select w-100"
                                                onChange={this.onChangeHandler}
                                            >
                                                <option value="0">-- Select --</option>
                                                {tcData.map((item, index) => (
                                                    <option key={index} value={item.TravelCircuitId}>
                                                        {item.TravelCircuitName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Location <span className='text-danger'>*</span></label>
                                            <select
                                                name="locationId"
                                                value={locationId}
                                                className="form-control-sm border border-primary form-select w-100"
                                                onChange={this.onChangeHandler}
                                            >
                                                <option value="0">-- Select --</option>
                                                {locationData.map((item, index) => (
                                                    <option key={index} value={item.LocationId}>
                                                        {item.LocationName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Car Vendor <span className='text-danger'>*</span></label>
                                            <select
                                                name="vendorId"
                                                value={vendorId}
                                                className="form-control-sm border border-primary form-select w-100"
                                                onChange={this.onChangeHandler}
                                            >
                                                <option value="0">-- Select --</option>
                                                {vendorData.map((item, index) => (
                                                    <option key={index} value={item.VendorId}>
                                                        {item.VendorName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-10">
                                            <label className="form-label">Car Name <span className='text-danger'>*</span></label>
                                            <Select
                                                name="selectedCar"
                                                closeMenuOnSelect={true}
                                                menuPlacement="bottom" // Positions the dropdown above
                                                menuPosition="absolute"
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }) // Ensures it's above everything
                                                }}
                                                menuPortalTarget={document.body}
                                                //components={this.state.AnimatedComponents}
                                                options={this.state.carData}
                                                isMulti
                                                onChange={this.onChangeCar}
                                                value={selectedCar}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">No. of Cars <span className='text-danger'>*</span></label>
                                            <input type="text" name="noOfCars" className="form-control-sm border border-primary w-100" value={(noOfCars) || 0} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Pick Up <span className='text-danger'>*</span></label>
                                            <input type="text" name="pickupPoint" className="form-control-sm border border-primary w-100" value={pickupPoint} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Drop <span className='text-danger'>*</span></label>
                                            <input type="text" name="dropPoint" className="form-control-sm border border-primary w-100" value={dropPoint} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Start Date <span className='text-danger'>*</span></label>
                                            <input type="date" name="checkInDate" className="form-control-sm border border-primary w-100" value={checkInDate} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">End Date <span className='text-danger'>*</span></label>
                                            <input type="date" name="checkOutDate" className="form-control-sm border border-primary w-100" value={checkOutDate} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-12">
                                            <label className="form-label">Comments</label>
                                            <textarea
                                                name="comment"
                                                className="form-control border border-secondary"
                                                rows="2"
                                                value={comment}
                                                onChange={this.onChangeHandler}></textarea>
                                        </div>
                                    </div>
                                    <div className="card mb-1 mt-2">
                                        <div className="card-head text-center">Vendor Payment</div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-label">Vendor Payable <span className='text-danger'>*</span></label>
                                                    <input type="number" name="payableAmount" className="form-control-sm border border-primary w-100" value={payableAmount} onChange={this.onChangeHandler} />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label">Paid to Vendor</label>
                                                    <input type="number" name="paidAmount" className="form-control-sm border border-primary w-100" value={paidAmount} disabled onChange={this.onChangeHandler} />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label">Due to Vendor</label>
                                                    <input type="number" name="dueAmount" className="form-control-sm border border-primary w-100" value={dueAmount} disabled onChange={this.onChangeHandler} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer my-3">
                                <button className="btn btn-success button-box-shadow" onClick={this.saveSubBooking}>
                                    <i className="fa-solid fa-circle-check"></i> Save
                                </button>

                                <button className="btn btn-secondary button-box-shadow" onClick={this.closeModal}>
                                    <i className="fa-solid fa-circle-xmark"></i> Close
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
                {/* <!-- Car modal section--> */}
            </>
        );
    }
}

export default CarSubBooking;